import type { HistoryEntry } from "../mockData";

function TrophySvg({ size }: { size: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
      <path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6"/><path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18"/><path d="M4 22h16"/><path d="M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22"/><path d="M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22"/><path d="M18 2H6v7a6 6 0 0 0 12 0V2z"/>
    </svg>
  );
}

function ResultBadge({ result, deltaLabel }: { result: "great" | "ok"; deltaLabel: string }) {
  const isGreat = result === "great";
  return (
    <div className="text-right">
      <span className="inline-flex h-5 px-2 rounded-full text-[10px] font-[500]"
        style={isGreat
          ? { background: "#EAF3DE", color: "#27500A" }
          : { background: "#E6F1FB", color: "#185FA5" }}>
        {isGreat ? "Перевыполнен" : "Выполнено в срок"}
      </span>
      <div className="text-[10px] mt-0.5" style={{ color: isGreat ? "#27500A" : "rgba(28,28,28,0.4)" }}>
        {deltaLabel}
      </div>
    </div>
  );
}

function HistorySummary({ history }: { history: HistoryEntry[] }) {
  const onTime = history.filter((h) => h.result === "ok" || h.result === "great").length;
  const pctOnTime = Math.round((onTime / history.length) * 100);
  const items = [
    { v: String(history.length), label: "РК закрыто",  accent: false },
    { v: `${pctOnTime}%`,        label: "в срок",      accent: true },
    { v: "0",                    label: "отказов",     accent: true },
    { v: "4.9 ★",                label: "рейтинг",    accent: false },
  ];
  return (
    <div className="flex items-stretch mb-5 rounded-md bg-white border border-ink-12 overflow-hidden">
      {items.map((item, i) => (
        <div key={i} className="flex-1 flex flex-col items-center py-3 px-2"
          style={{ borderRight: i < items.length - 1 ? "0.5px solid rgba(28,28,28,0.12)" : "none" }}>
          <span className="font-display font-[500] text-[19px] leading-tight"
            style={item.accent ? { color: "#27500A" } : {}}>
            {item.v}
          </span>
          <span className="text-[10px] text-ink-40 mt-0.5">{item.label}</span>
        </div>
      ))}
    </div>
  );
}

export function HistoryTab({ history }: { history: HistoryEntry[] }) {
  if (history.length === 0) {
    return (
      <div className="text-center py-10 text-ink-40">
        <p className="text-[13px] mb-3">Первая РК с этим блогером</p>
        <button className="h-8 px-4 rounded-pill text-[12px] font-display font-semibold"
          style={{ background: "#AADB54", color: "#1A3A05" }}>
          + Добавить в РК
        </button>
      </div>
    );
  }

  const niche = history.length > 2 ? "edtech и fintech" : "выбранной категории";

  return (
    <div>
      <HistorySummary history={history} />
      <div>
        {history.map((h, i) => (
          <div key={i} className="flex items-center justify-between py-3"
            style={{ borderBottom: i < history.length - 1 ? "0.5px solid rgba(28,28,28,0.1)" : "none" }}>
            <div>
              <div className="text-[12px] font-[500]">{h.brand}</div>
              <div className="text-[11px] text-ink-40">{h.formatLabel} · {h.date}</div>
            </div>
            <ResultBadge result={h.result} deltaLabel={h.deltaLabel} />
          </div>
        ))}
      </div>
      <div className="flex items-center gap-1.5 mt-4 text-[11px] text-ink-40 px-1"
        style={{ color: "#27500A" }}>
        <TrophySvg size={13} />
        <span>{history.length} из {history.length} РК — {niche}. Стабильный перформанс в категории.</span>
      </div>
    </div>
  );
}
